import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-form-error-message',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <small *ngIf="errorMessages?.length" class="error" style="margin-top: 5px">
            <ng-container *ngFor="let message of errorMessages">
                <div [innerHTML]="message"></div>
            </ng-container>
        </small>
    `,
    styles: [`
        :host {
            display: block;
        }
    `]
})

export class ErrorMessageComponent implements OnInit, OnDestroy {

    @Input() fbControl: FormControl = new FormControl();

    private sub: Subscription;

    public errorMessages: string[] = [];

    constructor(
        private cd: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
        this.sub = this.fbControl.statusChanges.subscribe(() => {
            this.getErrorMessages();
            this.cd.detectChanges();
        });

        this.getErrorMessages();
    }

    private getErrorMessages() {
        const errors = this.fbControl.errors;
        this.errorMessages = [];

        if (!errors) {
            return;
        }

        Object.keys(errors).forEach(key => {
            const message = errors[key];
            if (message) {
                this.errorMessages.push(message);
            }
        });
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
